import React, { useState, useEffect } from 'react';
import RMCard from './RMCard';
import RMEditModal from './RMEditModal';
import { Button, Flex } from 'antd';
import { EditOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import useRoleCheck from 'utilities/hooks/roleCheck';

const RegionalManagers = ({region, onChange}) => {
    const { hasPermission } = useRoleCheck();

    const [showButtons, setShowButtons] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);

    const scrollRef = React.createRef();

    const handleScroll = (scrollOffset) => {
      scrollRef.current.scrollLeft += scrollOffset;
    };

    useEffect(() => {
      const checkOverflow = () => {
        if (scrollRef.current) {
          setShowButtons(scrollRef.current.scrollWidth > scrollRef.current.clientWidth);
        }
      };
  
      checkOverflow();
      window.addEventListener('resize', checkOverflow);
      return () => window.removeEventListener('resize', checkOverflow);
    }, [scrollRef]);

    const fadeButtonStyle = (direction) => ({
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      background: direction === 'left'
        ? 'linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))'
        : 'linear-gradient(to left, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))',
      border: 'none',
      zIndex: 1,
      padding: '0 10px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      width: 20
    });

    return (
      <Flex align='center' justify='flex-start' wrap='flex-wrap' style={{ width: '100%', overflowX: 'hidden' }}>
      {showButtons && (
        <Button
          type="text"
          icon={<LeftOutlined />}
          onClick={() => handleScroll(-250)}
          style={{ ...fadeButtonStyle('left') }}
        />
      )}
      <Flex ref={scrollRef} align='center' justify='flex-start' wrap='flex-wrap' style={{  overflowX: 'hidden', scrollBehavior: 'smooth', maxWidth: '100%' }}>
        {region.rms?.map((rm) => {
          return <RMCard key={rm.id} rm={rm} />;
        })}
      </Flex>
      {showButtons && (
        <Button
          type="text"
          icon={<RightOutlined />}
          onClick={() => handleScroll(250)}
          style={{ ...fadeButtonStyle('right'), right: 30 }}
        />
      )}
      {hasPermission(["Admin.Basic", "Admin.Manage"], ["Sales.Exec"], region.regionCode, false) && (
        <Button
          type="text"
          icon={<EditOutlined />}
          style={{ marginLeft: 10 }}
          onClick={() => setEditModalOpen(true)}
        />
      )}
      <RMEditModal open={editModalOpen} onClose={() => setEditModalOpen(false)} region={region} onChange={onChange} />
    </Flex>
    );
};

export default RegionalManagers;